(function () {
  if (window.__edulandShipTimer) return;
  window.__edulandShipTimer = true;

  var DURATION = 60 * 60 * 1000;

  function datedKey() {
    var d = new Date();
    return 'eduland_free_ship_end_' + [d.getFullYear(), d.getMonth() + 1, d.getDate()].join('-');
  }

  function getEndAt() {
    var keys = [datedKey(), 'eduland_free_ship_end'];
    for (var i = 0; i < keys.length; i++) {
      var value = parseInt(localStorage.getItem(keys[i]) || '', 10);
      if (value && !isNaN(value)) return value;
    }
    var endAt = Date.now() + DURATION;
    localStorage.setItem(datedKey(), String(endAt));
    localStorage.setItem('eduland_free_ship_end', String(endAt));
    return endAt;
  }

  function format(ms) {
    var total = Math.max(0, Math.floor(ms / 1000));
    var pad = function (n) {
      return String(n).padStart(2, '0');
    };
    return pad(Math.floor(total / 3600)) + ':' + pad(Math.floor((total % 3600) / 60)) + ':' + pad(total % 60);
  }

  function tick() {
    var left = getEndAt() - Date.now();
    var expired = left <= 0;
    var text = format(left);
    document.documentElement.classList.toggle('eduland-ship-expired', expired);
    document.querySelectorAll('[data-eduland-ship-clock]').forEach(function (el) {
      el.textContent = text;
      var box = el.closest('.eduland-free-ship, .eduland-fis, .eduland-ann-promo');
      if (box) box.classList.toggle('is-expired', expired);
    });
    document.querySelectorAll('.eduland-fis, .eduland-free-ship, .eduland-ann-promo').forEach(function (el) {
      el.classList.toggle('is-expired', expired);
    });
  }

  function start() {
    tick();
    setInterval(tick, 1000);
    document.addEventListener('visibilitychange', tick);
    window.addEventListener('storage', function (event) {
      if (event.key && event.key.indexOf('eduland_free_ship_end') === 0) tick();
    });
    if (document.body) {
      new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var nodes = mutations[i].addedNodes;
          for (var j = 0; j < nodes.length; j++) {
            var node = nodes[j];
            if (
              node.nodeType === 1 &&
              (node.matches('[data-eduland-ship-clock]') || node.querySelector('[data-eduland-ship-clock]'))
            ) {
              tick();
              return;
            }
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
